import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  reversalQueue: {
    currentPage: 1,
    pages: {},
    totalCount: 0,
    loading: false,
    filter: {
      fulfillingPharmacyId: undefined,
      createdAtFrom: undefined,
      createdAtTo: undefined,
      lotNumber: undefined,
      drugName: undefined,
      ndc: undefined,
    },
    sort: { field: 'CREATED_AT', order: 'DESC' },
  },
};

/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    loadInventoryQueueToPage(state, action) {
      const { queue, page, items, totalCount } = action.payload;
      state[queue].pages[page] = items;
      state[queue].totalCount = totalCount;
    },
    updateInventoryQueuePage(state, action) {
      const { queue, page } = action.payload;
      state[queue].currentPage = page;
    },
    updateInventoryQueueFilter(state, action) {
      const { queue, filter } = action.payload;
      state[queue].pages = {};
      state[queue].totalCount = 0;
      state[queue].currentPage = 1;
      state[queue].filter = filter;
    },
    setInventoryQueueLoading(state, action) {
      const { queue, loading } = action.payload;
      state[queue].loading = loading;
    },
    updateInventoryQueueSort(state, action) {
      const { queue, sort } = action.payload;
      state[queue].pages = {};
      state[queue].totalCount = 0;
      state[queue].currentPage = 1;
      state[queue].sort = sort;
    },
  },
});

export const inventoryActions = inventorySlice.actions;
export default inventorySlice.reducer;
